import { REGIONS } from "@frontier/content/contracts";
import {
  INTEREST_EXIT_RADIUS as TARGET_RADIUS,
} from "@frontier/content/risk";
import type { ShipSnapshot, WorldSnapshot } from "@frontier/protocol/contracts";

export { TARGET_RADIUS };
export interface ResourceTarget {
  id: string;
  name: string;
  kind: "asteroid";
  x: number;
  y: number;
  radius: number;
  hp: number;
  maxHp: number;
  shield: number;
  maxShield: number;
}
export type AttackableTarget = ShipSnapshot | ResourceTarget;
export function physicalRegion(point: {
  x: number;
  y: number;
}): string | undefined {
  return REGIONS.find(
    (region) =>
      point.x >= region.x &&
      point.x < region.x + region.width &&
      point.y >= region.y &&
      point.y < region.y + region.height,
  )?.id;
}
export function attackableTargets(
  world: WorldSnapshot,
  pilot: ShipSnapshot,
  friends: readonly string[],
): AttackableTarget[] {
  const region = physicalRegion(pilot);
  if (pilot.dead || pilot.docked) return [];
  const ships = [...world.npcs, ...world.players].filter((target) => {
    if (
      target.id === pilot.id ||
      target.dead ||
      target.docked ||
      target.hp <= 0 ||
      target.kind === "transport" ||
      Math.hypot(target.x - pilot.x, target.y - pilot.y) > TARGET_RADIUS ||
      physicalRegion(target) !== region
    )
      return false;
    const player = target.kind === "pilot" || target.kind === "player";
    if (target.kind === "security")
      return target.securityTargetId === pilot.id && pilot.wanted === true;
    return (
      !player ||
      (pilot.pvpEnabled === true &&
        target.pvpEnabled === true &&
        pilot.factionId !== null &&
        target.factionId !== null &&
        (pilot.wanted === true || target.wanted === true ||
          (pilot.factionId !== target.factionId && !friends.includes(target.id))))
    );
  });
  const resources: ResourceTarget[] = world.obstacles.flatMap((rock) =>
    rock.resourceHp !== undefined && rock.resourceMaxHp !== undefined &&
    rock.resourceHp > 0 && physicalRegion(rock) === region &&
    Math.hypot(rock.x - pilot.x, rock.y - pilot.y) <= TARGET_RADIUS
      ? [{ id: rock.id, name: "Рудный астероид", kind: "asteroid", x: rock.x, y: rock.y,
          radius: rock.radius, hp: rock.resourceHp, maxHp: rock.resourceMaxHp, shield: 0, maxShield: 0 }]
      : [],
  );
  return [...ships, ...resources];
}
export function findAttackableTarget(
  world: WorldSnapshot,
  pilot: ShipSnapshot,
  targetId: string,
  friends: readonly string[],
): AttackableTarget | undefined {
  return attackableTargets(world, pilot, friends).find(
    (target) => target.id === targetId,
  );
}
